export type AvailableJobTypes = 'Export' | 'Import';

export enum JobTypes {
  Export = 'Export',
  Import = 'Import',
}
